import React from "react";
import { chunk } from "lodash";
import { useSelector } from "react-redux";
import { FormControl, Grid, Typography } from "@mui/material/";
import { useAssetTypeAttributes } from "../../hooks";

const CHUNK_SIZE = 2;

type Props = {
    assetTypeId: number,
    attributes: Array<any>
};

/**
 * Attributes Component
 */
export default ({ assetTypeId, attributes }: Props) => {
    const { typesList } = useSelector((state) => state);
    const assetTypeAttributes = useAssetTypeAttributes(assetTypeId || 0);

    const rows = React.useMemo(() => {
        return chunk(attributes, CHUNK_SIZE);
    }, [attributes]);

    const makeColumn = (label: string, value: any) => (
        <FormControl fullWidth margin="dense">
            <Typography variant="caption">{label}</Typography>
            <Typography variant="body2">{value || "\u2014"}</Typography>
        </FormControl>
    );

    return (
        <Grid container spacing={3}>
            <Grid item xs={6}>
                {rows.map(([first], index) => (
                    <React.Fragment key={index}>
                        {makeColumn(
                            assetTypeAttributes[first.attribute],
                            first.value
                        )}
                    </React.Fragment>
                ))}
            </Grid>
            <Grid item xs={6}>
                {rows.map(([first, second], index) => (
                    <React.Fragment key={index}>
                        {second &&
                            makeColumn(
                                assetTypeAttributes[second.attribute],
                                second.value
                            )}
                    </React.Fragment>
                ))}
            </Grid>
        </Grid>
    );
};
